import { GridLayoutItem as FoundationGridLayoutItem, foundationGridLayoutItemTemplate as zeroGridLayoutItemTemplate, foundationGridLayoutItemShadowOptions as zeroGridLayoutItemShadowOptions, defaultGridLayoutItemConfig, } from '@genesislcap/foundation-ui';
/**
 * @tagname %%prefix%%-grid-layout-item
 */
export class GridLayoutItem extends FoundationGridLayoutItem {
}
/**
 * The Zero Grid Layout Item
 *
 * @public
 * @remarks
 * HTML Element: \<zero-grid-layout-item\>
 */
export const zeroGridLayoutItem = GridLayoutItem.compose(Object.assign({ baseName: 'grid-layout-item', shadowOptions: zeroGridLayoutItemShadowOptions, template: zeroGridLayoutItemTemplate }, defaultGridLayoutItemConfig));
